const initState = {
  // 腾讯adq
  isInit: false, // 是否初始化State数据
  isDetailPage: false, // 是否为详情页
  isModifyPage: false, // 是否为修改页面
  // 公共
  isPublicPage: false, // 公共广告页面
  isPublicCreatePage: false, // 是否为公共创建页
  isPublicDetailPage: false, // 是否为公共详情页
  isPublicModifyPage: false // 是否为公共编辑页
}
const state = {
  ...initState,
  initState() {
    return initState
  }
}
const mutations = {
  getIsInitFlag(state, data) {
    state.isInit = data
    console.log(state.isInit, '我是isInit-Flag')
  },
  getIsDetailPage(state, data) {
    state.isDetailPage = data
    console.log(state.isDeatilPage, '我是详情页')
  },
  getIsModifyPage(state, data) {
    state.isModifyPage = data
    console.log(state.isModifyPage, '我是修改页')
  },
  // 公共
  getIsPublicPage(state, data) {
    state.isPublicPage = data
    console.log(state.isPublicPage, '我是isPublicPage')
  },
  getIsPublicCreatePage(state, data) {
    state.isPublicCreatePage = data
    console.log(state.isPublicCreatePage, '我是isPublicCreatePage')
  },
  getIsPublicDetailPage(state, data) {
    state.isPublicDetailPage = data
    console.log(state.isPublicDetailPage, '我是isPublicDetailPage')
  },
  getIsPublicModifyPage(state, data) {
    state.isPublicModifyPage = data
    console.log(state.isPublicModifyPage, '我是isPublicModifyPage')
  }
}
export default {
  namespaced: true,
  state,
  mutations
}
// ...mapState('createAdvertPlan/createAdvert', ['isInit']),

// setData() {
//   this.isInit ? this.initStateData() : this.restoreStateData()
// },

// whatPage() {
//   if(this.isDetailPage) {

//   }
// }
// :disabled="isDetailPage ? true : false"
// goBackPage() {
//   // 调用全局挂载的方法,关闭当前标签页
//   this.$store.dispatch('tagsView/delView', this.$route)
//   // 返回到指定路由
//   this.$router.push({ path: '/customer/accountList/tencentAdqAdvertManage/index' })
// },
